import ResourceManager, { ActiveBadge } from "@/components/admin/ResourceManager";

const fields = [
    { name: "question", label: "Question", type: "text", required: true },
    { name: "answer", label: "Answer", type: "textarea", rows: 5, required: true },
    { name: "category", label: "Category", type: "text", default: "General", placeholder: "Pricing, Timeline, SEO..." },
    { name: "order", label: "Sort order", type: "number" },
    { name: "is_active", label: "Active", type: "switch", default: true, toggleLabel: "Visible on site" },
];

const columns = [
    { key: "question", label: "Question" },
    { key: "category", label: "Category" },
    { key: "is_active", label: "Status", render: (r) => <ActiveBadge active={r.is_active} /> },
    { key: "order", label: "Order" },
];

export default function FaqsPage() {
    return (
        <ResourceManager
            title="FAQs"
            description="Common questions and answers shown on the public FAQs section."
            endpoint="faqs"
            columns={columns}
            fields={fields}
            testidPrefix="faqs"
            searchKeys={["question", "category"]}
        />
    );
}
